import { ROUTES } from '../../consts/Routes'
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '../../reducers/hooks'

export interface AuthType {
  authed: boolean
}

export const isAuthenticatedAdmin = (): boolean => {
  const token = useAppSelector((state) => state.user.token)
  const lsToken = localStorage.getItem('token')
  const isInternalUser = useAppSelector((state) => state.user.internalUser)
  const lsIsInternalUser = localStorage.getItem('internalUser')
  if ((token !== null || lsToken !== null) && (isInternalUser === 'true' || lsIsInternalUser === 'true')) return true
  return false
}

export const useAuth = (): AuthType => {
  return { authed: isAuthenticatedAdmin() }
}
const ProtectedAdminRoutes: React.FC = (): JSX.Element => {
  const { authed } = useAuth()
  return authed ? <Outlet /> : <Navigate to={ROUTES.HOME} />
}

export default ProtectedAdminRoutes
